// npm
import React from 'react'
import {
  Link,
} from "react-router-dom"

// local
import { menu } from '../lib/constants.js'
import classNames from '../lib/class-names.js'

export default function MobileNav() {
  return (
    <nav className="px-2 space-y-1">
      {
        menu.map(item =>
          <Link
            key={ item.name }
            to={ item.href }
            className={ classNames(
              item.current ? 'bg-indigo-800 text-white' : 'text-indigo-100 hover:bg-indigo-600',
              'group flex items-center px-2 py-2 text-base font-medium rounded-md'
            ) }
          >
            <item.icon className="mr-4 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" />
            { item.name }
          </Link>
        )
      }
    </nav>
  )
}
